// Check if Yotpo is initialized
function yotpoSliderInit() {
  const reviewsWrapper = document.querySelector('[data-product-reviews]');
  const productReviews = document.querySelector('[data-product-template-reviews]');
  let mySwiper = null;
  const isProductTemplate = (productReviews !== null);

  const yotpoLoaded = setInterval(() => {
    const yotpoWrapper = document.querySelector('.main-widget');
    // If no reviews, add class and bail
    if (yotpoWrapper != null && yotpoWrapper.classList.contains('yotpo-no-reviews')) {
      reviewsWrapper.classList.add('no-reviews');
      clearInterval(yotpoLoaded);
      return;
    }

    // If reviews, make swiper, add click listener
    const yotpoReview = document.querySelector('.yotpo-review');
    if (yotpoReview !== null) {
      rejigLayout();
      rejigReviews();
      mySwiper = makeSwiper();
      disableSwiperOnDesktop();
      reviewLoadedChecker();
      clearInterval(yotpoLoaded);
    }
  }, 100);

  // Cancel interval if no reviews after 10 seconds
  setTimeout(() => {
    clearInterval(yotpoLoaded);
  }, 10000);

  function makeSwiper() {
    const yotpoReviews = document.querySelector('.yotpo-reviews');
    const sliderContainer = document.createElement('div');
    sliderContainer.classList.add('swiper-container', 'reviews-slider');
    sliderContainer.setAttribute('data-product-reviews-swiper-container', '');
    const sliderWrapper = document.createElement('div');
    sliderWrapper.classList.add('swiper-wrapper');
    sliderContainer.prepend(sliderWrapper);
    yotpoReviews.prepend(sliderContainer);

    initSwiper(sliderContainer);

    const yotpoReviewsList = yotpoReviews.querySelectorAll('.yotpo-review:not(.yotpo-hidden)');
    if (yotpoReviewsList !== null) {
      const yotpoReviewArrays = [...yotpoReviewsList];
      yotpoReviewArrays.forEach((review) => {
        review.classList.add('swiper-slide');
        mySwiper.appendSlide(review);
      });
    }
    return mySwiper;
  }

  function initSwiper(sliderContainer) {
    const options = {
      slidesPerView: 'auto',
      centeredSlides: false,
      freeMode: true,
      loop: false,
      mousewheel: {
        forceToAxis: true,
        eventsTarget: '.reviews-slider',
        invert: true,
      },
      navigation: {
        nextEl: '.swiper-nav__btn--next',
        prevEl: '.swiper-nav__btn--prev',
      },
    };

    mySwiper = new Swiper(sliderContainer, options);
  }

  function rejigLayout() {
    const bottomLine = reviewsWrapper.querySelector('.yotpo-bottomline');
    const yotopLabel = reviewsWrapper.querySelector('.yotpo-label');
    const yotopLabelClear = yotopLabel.querySelector('.yotpo-clr');
    const writeReviewButton = reviewsWrapper.querySelector('.write-review-button');
    const bottomLineEls = document.querySelectorAll('[data-yotpo-bottomline-container]');

    if (bottomLine == null) { return; }
    bottomLine.classList.remove('pull-left');
    writeReviewButton.classList.remove('pull-right');
    yotopLabelClear.remove();
    yotopLabel.appendChild(bottomLine);
    yotopLabel.appendChild(writeReviewButton);

    if (bottomLineEls == null) { return; }
    const bottomLineClone = bottomLine.cloneNode(true);
    bottomLineEls.forEach(bottomLineEl => {
      bottomLineEl.append(bottomLineClone);
    });
  }

  function rejigReviews() {
    const yotpoReviewsList = document.querySelectorAll('.yotpo-review:not(.yotpo-hidden)');
    yotpoReviewsList.forEach(review => {
      const reviewHeader = review.querySelector('.yotpo-header');
      const reviewFooter = review.querySelector('.yotpo-footer');
      const reviewStars = review.querySelector('.yotpo-review-stars');
      const reviewStarsClone = reviewStars.cloneNode(true);
      const reviewName = review.querySelector('.yotpo-user-name');
      const reviewNameClone = reviewName.cloneNode(true);
      const reviewVerified = reviewHeader.querySelector('.label-with-tooltip');
      const reviewhelpfulLabel = review.querySelector('.label-helpful');

      if (reviewVerified !== null) {
        const reviewVerifiedClone = reviewVerified.cloneNode(true);
        reviewVerifiedClone.classList.add('verified-buyer');
        reviewFooter.prepend(reviewVerifiedClone);
        reviewVerified.remove();
      }
      reviewHeader.appendChild(reviewStarsClone);
      reviewFooter.prepend(reviewNameClone);

      reviewhelpfulLabel.innerText = 'Was This Helpful?';

      // Cleanup
      reviewName.remove();
      reviewStars.remove();
    });
  }

  function reviewLoadedChecker() {
    const yotpoReviews = document.querySelector('.yotpo-reviews');
    document.querySelectorAll('.yotpo-page-element').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        if (trigger.classList.contains('yotpo-disabled')) {
          return;
        }
        yotpoReviews.style.visibility = 'hidden';
        const checkReviewsLoading = setInterval(() => {
          const yotpoReviewsList = yotpoReviews.querySelectorAll('.yotpo-review:not(.yotpo-hidden)');
          if (yotpoReviewsList != null && yotpoReviewsList.length > 0 && !yotpoReviewsList[0].classList.contains('swiper-slide')) {
            rejigReviews();
            mySwiper = makeSwiper();
            disableSwiperOnDesktop();
            yotpoReviews.style.visibility = 'visible';
            clearInterval(checkReviewsLoading);
            reviewLoadedChecker();
          }
        }, 50);
      });
    });
  }

  const breakpoint = window.matchMedia('(min-width: 750px)');
  breakpoint.addListener(disableSwiperOnDesktop);

  function disableSwiperOnDesktop() {
    if (!isProductTemplate) { return; }
    const swiperContainer = document.querySelector('[data-product-reviews-swiper-container]');
    if (swiperContainer === null) { return; }

    if (breakpoint.matches === true) {
      if (mySwiper !== null && typeof mySwiper !== 'undefined') {
        swiperContainer.classList.add('destroyed');
        mySwiper.destroy(true, true);
        mySwiper = null;
      }
    } else {
      initSwiper(swiperContainer);
      swiperContainer.classList.remove('destroyed');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  yotpoSliderInit();
});
